// `CanvasRenderingContext2D.roundRect` is missing on Safari < 16 (iOS <= 15, still common on
// older iPhones) — every call throws "roundRect is not a function" and crashes whatever canvas
// draw it happened in (device screen alpha masks, editor position pads). Polyfill with the
// standard rounded-rect path algorithm so those call sites work unmodified on older browsers.
export const ensureRoundRectSupport = (): void => {
  const proto = CanvasRenderingContext2D.prototype as CanvasRenderingContext2D & {roundRect?: unknown}
  if (typeof proto.roundRect === 'function') return

  proto.roundRect = function (
    this: CanvasRenderingContext2D,
    x: number,
    y: number,
    w: number,
    h: number,
    radii?: number | number[],
  ): void {
    const values = typeof radii === 'number' ? [radii, radii, radii, radii] : (radii ?? [0])
    const tl = values[0] ?? 0
    const tr = values[1] ?? tl
    const br = values[2] ?? tl
    const bl = values[3] ?? tr

    this.moveTo(x + tl, y)
    this.lineTo(x + w - tr, y)
    this.arcTo(x + w, y, x + w, y + tr, tr)
    this.lineTo(x + w, y + h - br)
    this.arcTo(x + w, y + h, x + w - br, y + h, br)
    this.lineTo(x + bl, y + h)
    this.arcTo(x, y + h, x, y + h - bl, bl)
    this.lineTo(x, y + tl)
    this.arcTo(x, y, x + tl, y, tl)
  }
}

ensureRoundRectSupport()
